const save = (name, value) => localStorage.setItem(name, JSON.stringify(value));

const get = (name) => {
  const val = localStorage.getItem(name);
  if (!val) return null;

  try {
    return JSON.parse(val);
  } catch (e) {
    console.error(`Error parsing cached data for key ${name}, error: `, e);
    return null;
  }
};

const simpleGet = (name) => localStorage.getItem(name);

const remove = (name) => localStorage.removeItem(name);

const getWithExpiry = (key) => {
  const itemStr = get(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    remove(key);
    return null;
  }
  return item.value;
};

const saveWithExpiry = (key, value, ttl) => {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttl,
  };
  save(key, JSON.stringify(item));
};

// Storage key names
export const STORAGE_KEYS = {
  defaultPage: 'default_page',
};

export default {
  save,
  get,
  simpleGet,
  remove,
  getWithExpiry,
  saveWithExpiry,
  STORAGE_KEYS,
};
